module.exports = __webpack_public_path__ + "img/92.891cada8.svg";